import { Component, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogService } from '@app/old-ui/dialog/dialog.service';
import { ConnectionManager } from '@app/utilities/foblex-flow/connection-manager';
import { FlowNode, NodeManager } from '@app/utilities/foblex-flow/node-manager';
import { FReassignConnectionEvent } from '@foblex/flow';
import { WebClient } from '@injectables';
import { Device, fragQuery } from '@models';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { FragQueryService } from 'src/injectables/frag-query.service';
import { DeviceNode } from './nodes/device-node/device-node.component';
import { NodesComponent } from './nodes/nodes.component';

interface ChartData {
    device: Device;
    accumulatedSummary: fragQuery.timeline.sieveSizesAtPercents.Interval | null;
}
@Component({
    selector: 'flow-board',
    templateUrl: './flow-board.component.html',
    styleUrls: ['./flow-board.component.scss']
})
export class FlowBoardComponent {

    public readonly selectedDevicesToChart$: BehaviorSubject<Device[]> = new BehaviorSubject<Device[]>([]);
    public readonly chartsData$: Observable<ChartData[]>;
    public readonly nodeClient = this.webClient.model.node;
    public readonly nodes$ = this.fragQuery.nodes$;
    public nodes: FlowNode[] = [];
    public loading$ = this.fragQuery.nodesLoading$

    constructor(
        private readonly dialog: DialogService,
        private readonly fragQuery: FragQueryService,
        private readonly webClient: WebClient,
        private readonly snackBar: MatSnackBar,
        private readonly nodeManager: NodeManager,
        private readonly connectionManager: ConnectionManager,
    ) {}

    @ViewChild(NodesComponent)
    public nodesComponent!: NodesComponent;

    public zoomIn() { this.nodesComponent.zoomIn(); }
    public zoomOut() { this.nodesComponent.zoomOut(); }
    public resetZoom() { this.nodesComponent.resetZoom(); }

    public reassignConnection(event: FReassignConnectionEvent): void {
        if (!event.newFInputId) {
            return;
        }
        this.connectionManager.reassignConnection(event.fOutputId, event.oldFInputId, event.newFInputId)
    }

    public async saveFlow() {
        this.nodes = this.nodeManager.getNodes();
        if (!this.nodes) return;

        const deviceNodeUpdateRequests = this.getdeviceNodeUpdatePromises()

        try {
            await this.dialog.await(Promise.all(deviceNodeUpdateRequests));
            this.fragQuery.clearCachedPositions();
            this.fragQuery.trigger$.next();
            this.snackBar.open('Flow saved successfully', 'OK', {
                duration: 5000,
                panelClass: ['snackbar-success'],
            });
        } catch (error) {
            console.error('Failed to save some nodes:', error);
        }
    }

    private getdeviceNodeUpdatePromises = (): Promise<Boolean>[] => {
        const saveRequests = this.nodes.map((node) => {
            if(DeviceNode.isDeviceNode(node)) {
                return this.nodeClient.save(node.toNode());
            }else{
                return undefined;
            }
        });
        return saveRequests;
    }

    public openAddNodeDialog() {
        this.dialog.openCreateNodeDialog()
    }
}